import React from 'react';
import styled from 'styled-components';
import { withAuth, AuthState } from 'context/auth';
import { useLocation } from 'react-router-dom';

const StyledFooter = styled.footer`
  margin-top: auto;
  color: ${p => p.theme.colors.navFg};
  background-color: ${p => p.theme.colors.deepGrey};
`;
const StyledFooterContainer = styled.div`
  max-width: ${p => p.theme.contentMaxWidth};
  padding: 20px 16px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
  flex-wrap: wrap;
  font-size: ${p => p.theme.fontSize.base};

  a {
    color: ${p => p.theme.colors.navFg};
    text-decoration: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.45);
  }

  a:hover {
    border-bottom-color: currentColor;
  }
`;
const StyledIsoCert = styled.img`
  display: block;
  flex: 0 0 auto;
  width: 104px;
  height: 104px;
  padding: 6px;
  background-color: white;
  border-radius: 4px;
  object-fit: contain;
`;
const StyledFooterList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 0;
  padding: 0;
  list-style: none;
  line-height: 1.4;
  text-align: left;

  @media (max-width: 520px) {
    text-align: center;
  }
`;
const StyledFooterListItem = styled.li`
  margin: 0;
`;
const StyledCertificationText = styled.span`
  line-height: 1.4;
`;
const StyledPolicyLink = styled.a`
  line-height: 1.4;
`;

const certificationText = 'ISO 27001 certified';

interface Props {
  auth: AuthState;
  sandbox: Sandbox | undefined;
}

const FooterWrapper = (props: Props) => {
  let location = useLocation();

  const isVMPage = () => {
    const parts = location.pathname.split('/');
    return parts.pop() === 'vm';
  };

  if (isVMPage()) return null;

  const isocert = require('images/iso-cert.svg').default;

  const copyrightLink =
    props.auth.sandbox?.themeInformation?.copyright_url ||
    `${process.env.REACT_APP_COPYRIGHT_URL}`;
  const copyrightText =
    props.auth.sandbox?.themeInformation?.copyright ||
    `${process.env.REACT_APP_COPYRIGHT}`;

  return (
    <StyledFooter id="footer">
      <StyledFooterContainer>
        <StyledIsoCert
          id="iso-cert"
          src={isocert}
          alt="ISO 27001 Certified"
        />
        <StyledFooterList aria-label="Footer information">
          <StyledFooterListItem>
            {copyrightLink !== '' && (
              <span id="copyright-text">
                &copy;&nbsp;<a href={copyrightLink}>{copyrightText}</a>
              </span>
            )}
            {copyrightLink === '' && (
              <span id="copyright-text">&copy;&nbsp;{copyrightText}</span>
            )}
          </StyledFooterListItem>
          <StyledFooterListItem>
            <StyledCertificationText>{certificationText}</StyledCertificationText>
          </StyledFooterListItem>
          <StyledFooterListItem>
            <StyledPolicyLink
              href="https://drive.google.com/file/d/1bb3sC8RNvTbWAlCtigJX-BfkoltcwZt2"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Genes and Health TRE ISMS policy statement"
            >
              TRE ISMS policy statement
            </StyledPolicyLink>
          </StyledFooterListItem>
        </StyledFooterList>
      </StyledFooterContainer>
    </StyledFooter>
  );
};

const Footer = withAuth(FooterWrapper);

export { Footer };
